import { ReactionBarSelector } from "@charkour/react-reactions";
import { Box, ClickAwayListener, Grow, MenuItem, Paper, Popper } from "@mui/material";
import { forwardRef, useImperativeHandle } from "react";
import { BrowserView, MobileView, isBrowser, isMobile } from "react-device-detect";
import { isNullOrEmpty, objReactions } from "../common/common";
interface menuItemsParams {
  menuItem: any;
  handleClose?: any;
  setAnchorElement?: any;
  setOpenSheet?: any;
}

const CreateMenuItems = ({ menuItem, handleClose, setAnchorElement, setOpenSheet }: menuItemsParams) => {
  const onMenuItemClick = (e: any, v: any) => {
    e.stopPropagation();
    e.preventDefault();
    v.callback && v.callback(v);
    handleClose && handleClose();
    setOpenSheet && setOpenSheet(false);
    if (isMobile) {
      setTimeout(() => {
        setAnchorElement && setAnchorElement(null);
      }, 350);
    } else {
      setAnchorElement && setAnchorElement(null);
    }
  };
  return (
    <>
      {!isNullOrEmpty(menuItem) &&
        menuItem &&
        menuItem?.map((v: any, i: number) => {
          return (
            <MenuItem sx={{ minHeight: "48px !important" }} key={i} onClick={(e: any) => onMenuItemClick(e, v)}>
              {v.icon && <Box className="mar-r-8 flex">{v.icon}</Box>}
              {v.title && v.title}
            </MenuItem>
          );
        })}
    </>
  );
};

const CreateMenu = ({ anchorElement, setAnchorElement, menuItemList, onClose, sameView, placement }: any, ref?: any) => {
  const handleClose = () => {
    setAnchorElement(null);
    onClose && onClose();
  };

  useImperativeHandle(ref, () => ({
    hideMenu: () => {
      handleClose();
    },
  }));

  return anchorElement ? (
    <>
      {sameView ? (
        <Popper open={Boolean(anchorElement ? anchorElement : null)} anchorEl={anchorElement ? anchorElement : null} transition placement={placement ? placement : "bottom-end"}>
          {({ TransitionProps }) => (
            <Grow {...TransitionProps} timeout={350}>
              <Paper className="bor-t-r-b-l-4" sx={{ minWidth: "160px", padding: "8px 0" }}>
                <CreateMenuItems menuItem={menuItemList} handleClose={onClose ? onClose : () => {}} />
              </Paper>
            </Grow>
          )}
        </Popper>
      ) : (
        <>
          <ClickAwayListener onClickAway={handleClose}>
            <Popper open={Boolean(anchorElement ? anchorElement : null)} anchorEl={anchorElement ? anchorElement : null} transition placement={placement ? placement : "bottom-start"}>
              {({ TransitionProps }) => (
                <Grow {...TransitionProps} timeout={350}>
                  <Paper className="bor-t-r-b-l-4" sx={{ padding: "12px 0" }}>
                    <CreateMenuItems menuItem={menuItemList} handleClose={onClose ? onClose : () => {}} setAnchorElement={setAnchorElement} setOpenSheet={null} />
                  </Paper>
                </Grow>
              )}
            </Popper>
          </ClickAwayListener>
        </>
      )}
    </>
  ) : null;
};

export default forwardRef(CreateMenu);

export const CreateReactionsMenu = ({ anchorElement, setAnchorElement, onSelect, index }: any) => {
  const handleClose = (e: any) => {
    if (e.target !== anchorElement) {
      setAnchorElement(null);
    }
  };

  const onPopperOpen = () => {
    if (anchorElement) {
      const allEmojies: any = document.getElementsByClassName(isBrowser ? "reaction-popper" : "reactions-mob")[0]?.querySelectorAll("div")[0]?.childNodes;
      if (allEmojies) {
        allEmojies.forEach((element: any, ind: number) => {
          element.style.fontSize = "unset";
          if (ind === index) {
            element.style.backgroundColor = "var(--color-bright-sky-blue)";
            element.style.borderRadius = "50%";
          }
        });
      }
    }
  };
  return anchorElement ? (
    <>
      <BrowserView>
        <ClickAwayListener onClickAway={handleClose}>
          <Popper open={Boolean(anchorElement ? anchorElement : null)} anchorEl={anchorElement ? anchorElement : null} placement="top" transition className="reaction-popper" sx={{ marginTop: "4px !important", marginBottom: "4px !important" }}>
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} timeout={350} addEndListener={onPopperOpen}>
                <ReactionBarSelector
                  iconSize={32}
                  style={{ boxShadow: "unset", border: "1px solid var(--color-light-gray)" }}
                  reactions={objReactions}
                  onSelect={(key: string) => {
                    onSelect(key);
                  }}
                />
              </Grow>
            )}
          </Popper>
        </ClickAwayListener>
      </BrowserView>
      <MobileView>
        <ClickAwayListener onClickAway={handleClose}>
          <Popper className={`reactions-mob`} open={Boolean(anchorElement ? anchorElement : null)} anchorEl={anchorElement ? anchorElement : null} transition placement="top-end">
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} timeout={350} addEndListener={onPopperOpen}>
                <ReactionBarSelector
                  iconSize={32}
                  reactions={objReactions}
                  onSelect={(key: string) => {
                    onSelect(key);
                  }}
                />
              </Grow>
            )}
          </Popper>
        </ClickAwayListener>
      </MobileView>
    </>
  ) : null;
};
